import apiClient from './apiClient';

export async function listHeroSlides() {
  const { data } = await apiClient.get('/api/admin/hero-slides');
  return data;
}

export async function createHeroSlide(payload) {
  const { data } = await apiClient.post('/api/admin/hero-slide', payload);
  return data;
}

export async function updateHeroSlide(id, payload) {
  const { data } = await apiClient.put(`/api/admin/hero-slide/${id}`, payload);
  return data;
}

export async function deleteHeroSlide(id) {
  const { data } = await apiClient.delete(`/api/admin/hero-slide/${id}`);
  return data;
}
